import axios from "common/helpers/axios.helper"

export const resetPortfolio = () => {
    return {
        type: "PORTFOLIO_RESET",
        payload: null
    }
}

export const getPortfolioList = () => {
    return (dispatch, getState) => {
        const { apiURL, token, currentContainer } = getState().app;

        dispatch({ type: 'PORTFOLIO_LIST_PENDING' });

        axios({
            url: encodeURI(apiURL + `/api/v1/portfolios/${currentContainer}`),
            method: 'GET',
            responseType: 'json',
            headers: { 'authorization': token, 'Content-Type': 'application/json' }
        }).then((response) => {
            dispatch({ type: 'PORTFOLIO_LIST_SUCCESS', payload: response.data });
        }).catch((error) => {
            dispatch({ type: 'PORTFOLIO_LIST_ERROR', payload: error.response })
        });
    }
}

export const getPortfolio = (id, modalDialog = null, modalType = null) => {
    return (dispatch, getState) => {
        const { apiURL, token, currentContainer } = getState().app;

        dispatch({ type: 'PORTFOLIO_SELECT_PENDING' });

        axios({
            url: encodeURI(apiURL + `/api/v1/portfolios/${currentContainer}/id/${id}`),
            method: 'GET',
            headers: { 'authorization': token, 'Content-Type': 'application/json' },
            responseType: 'json'
        }).then((response) => {
            dispatch({ type: 'PORTFOLIO_SELECT_SUCCESS', payload: response.data });
            if (modalDialog) {
                dispatch({ type: 'SET_MODAL_DIALOG', payload: { dialog: modalDialog, type: modalType } });
            }
        }).catch((error) => {
            dispatch({ type: 'PORTFOLIO_SELECT_ERROR', payload: error.response })
        });
    }
}

export const createPortfolio = (data) => {
    return (dispatch, getState) => {
        const { apiURL, token, currentContainer } = getState().app;

        dispatch({ type: 'PORTFOLIO_CREATE_PENDING' });

        axios({
            url: encodeURI(apiURL + `/api/v1/portfolios/${currentContainer}`),
            method: 'POST',
            headers: { 'authorization': token, 'Content-Type': 'application/json' },
            data: data,
            responseType: 'json'
        }).then((response) => {
            dispatch({ type: 'PORTFOLIO_CREATE_SUCCESS', payload: response.data });
            dispatch({ type: 'SET_MODAL_DIALOG', payload: { dialog: null, type: null } });
            dispatch(getPortfolioList())
        }).catch((error) => {
            dispatch({ type: 'PORTFOLIO_CREATE_ERROR', payload: error.response })
        });
    }
}

export const updatePortfolio = (id, data) => {
    return (dispatch, getState) => {
        const { apiURL, token, currentContainer } = getState().app;
        const { portfolioList } = getState().portfolio;

        delete data.type;
        delete data.path;
        delete data.timestamp;

        const mainList = portfolioList.filter((d) => d.id === id)
        if (mainList.length > 0) {
            data.children = mainList[0].children;
        }

        dispatch({ type: 'PORTFOLIO_UPDATE_PENDING' });

        axios({
            url: encodeURI(apiURL + `/api/v1/portfolios/${currentContainer}/id/${id}`),
            method: 'PATCH',
            headers: { 'authorization': token, 'Content-Type': 'application/json' },
            data: data,
            responseType: 'json'
        }).then((response) => {
            dispatch({ type: 'PORTFOLIO_UPDATE_SUCCESS', payload: response.data });
            dispatch({ type: 'SET_MODAL_DIALOG', payload: { dialog: null, type: null } });
            dispatch(getPortfolioList())
        }).catch((error) => {
            dispatch({ type: 'PORTFOLIO_UPDATE_ERROR', payload: error.response })
        });
    }
}

export const deletePortfolio = (id) => {
    return (dispatch, getState) => {
        const { apiURL, token, currentContainer } = getState().app;

        dispatch({ type: 'PORTFOLIO_DELETE_PENDING' });

        axios({
            url: encodeURI(apiURL + `/api/v1/portfolios/${currentContainer}/id/${id}`),
            method: 'DELETE',
            headers: { 'authorization': token, 'Content-Type': 'application/json' },
            responseType: 'json'
        }).then((response) => {
            dispatch({ type: 'PORTFOLIO_DELETE_SUCCESS', payload: response.data });
            dispatch({ type: 'SET_MODAL_DIALOG', payload: { dialog: null, type: null } });
            dispatch(getPortfolioList())
        }).catch((error) => {
            dispatch({ type: 'PORTFOLIO_DELETE_ERROR', payload: error.response })
        });
    }
}

export const scanPortfolio = (name, modalDialog = null, modalType = null, pathParam = null) => {
    return (dispatch, getState) => {
        const { apiURL, token, path, currentContainer } = getState().app;

        dispatch({ type: 'PORTFOLIO_SELECT_PENDING' });

        axios({
            url: encodeURI(apiURL + `/api/v1/portfolios/${currentContainer}/scan/${name}`),
            method: 'GET',
            headers: { 'authorization': token, 'Content-Type': 'application/json' },
            responseType: 'json'
        }).then((response) => {
            dispatch({ type: 'PORTFOLIO_SELECT_SUCCESS', payload: response.data });
            if (pathParam === null) {
                dispatch({ type: 'SET_PATH', payload: path });
            } else {
                dispatch({ type: 'SET_PATH', payload: pathParam });
            }
            if (modalDialog) {
                dispatch({ type: 'SET_MODAL_DIALOG', payload: { dialog: modalDialog, type: modalType } });
            }
        }).catch((error) => {
            dispatch({ type: 'PORTFOLIO_SELECT_ERROR', payload: error.response })
        });
    }
}

export const goLivePortfolio = (successCallback = null, errorCallback = null) => {
    return (dispatch, getState) => {
        const { apiURL, token, currentContainer } = getState().app;

        dispatch({ type: 'PORTFOLIO_CREATE_PENDING' });

        axios({
            url: encodeURI(apiURL + `/api/v1/portfolios/${currentContainer}/golive`),
            method: 'POST',
            timeout: 120 * 1000,
            headers: { 'authorization': token, 'Content-Type': 'application/json' },
            responseType: 'json'
        }).then((response) => {
            dispatch({ type: 'PORTFOLIO_CREATE_SUCCESS', payload: response.data });
            successCallback && successCallback(response.data);
        }).catch((error) => {
            dispatch({ type: 'PORTFOLIO_CREATE_ERROR', payload: error.response });
            errorCallback && errorCallback(error);
        });
    }
}

export const generatePortfolio = (successCallback = null, errorCallback = null) => {
    return (dispatch, getState) => {
        const { apiURL, token, currentContainer } = getState().app;

        dispatch({ type: 'PORTFOLIO_GENERATE_PENDING' });

        axios({
            url: encodeURI(apiURL + `/api/v1/portfolios/${currentContainer}/generate`),
            method: 'POST',
            timeout: 120 * 1000,
            headers: { 'authorization': token, 'Content-Type': 'application/json' },
            responseType: 'json'
        }).then((response) => {
            dispatch({ type: 'PORTFOLIO_GENERATE_SUCCESS', payload: response.data });
            successCallback && successCallback(response.data);
        }).catch((error) => {
            errorCallback && errorCallback(error);
            dispatch({ type: 'PORTFOLIO_GENERATE_ERROR', payload: error.response });
        });
    }
}

export const setPortfolioList = (json) => {
    return {
        type: "PORTFOLIO_LIST_SUCCESS",
        payload: json
    }
}

export const setCurrentPortfolio = (node) => {
    return {
        type: "SET_CURRENT_PORTFOLIO",
        payload: node
    }
}

export const setCurrentGroup = (node) => {
    return {
        type: "SET_CURRENT_GROUP",
        payload: node
    }
}

export const setCurrentProduct = (node) => {
    return {
        type: "SET_CURRENT_PRODUCT",
        payload: node
    }
}
